
import "/app/src/components/EnterpriseDetailModal/index.module.less?modules";
export default {"modal": `modal-T-HTx87x`}
